import ClientBuilder from '@/tools/client-builder';

import sspApiConfig from './sspApi'
import apiAdvice from './apiAdvice'

const builder = new ClientBuilder({
    baseURL: process.env.VUE_APP_SSP_URL,
    timeout: 30000,
    withCredentials: true,
})
.advice(apiAdvice);

const builder2 = new ClientBuilder({
    baseURL: process.env.VUE_APP_SSP_URL,
    timeout: 30000,
    withCredentials: true,
})


const sspApi = builder.build(sspApiConfig);

const sspApiNoAdvice = builder2.build(sspApiConfig);

export {
    sspApi, sspApiNoAdvice
}
